import { FC } from "react"
import {
  makeStyles,
  Tooltip as MuiTooltip,
  TooltipProps,
} from "@material-ui/core"
import React from "react"
import { colors } from "../../../utils/theme"
import clsx from "clsx"

const useStyles = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: colors.neutral.space,
    borderRadius: 4,
    padding: 12,
    border: 0,
  },
  arrow: {
    color: colors.neutral.space,
  },
}))

export const Tooltip: FC<TooltipProps> = ({
  children,
  className,
  placement = "right",
  ...props
}) => {
  const classes = useStyles()
  return (
    <MuiTooltip
      {...props}
      placement={placement}
      arrow={true}
      classes={{
        tooltip: clsx(classes.tooltip, className),
        arrow: classes.arrow,
      }}
    >
      {children}
    </MuiTooltip>
  )
}
